import React from 'react'
import ReactDOM from 'react-dom'
import App from '@src/containers/UtmGenerator'

window.startUTMGeneratorLink = () => {
  ReactDOM.render(<App />, document.getElementById('utm-generator-form'))
}
